import PageHeader from "core/components/Header/PageHeader";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { _t } from "core/language";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import EmptyData from "core/components/EmptyData/EmptyData";
import CDropdownCommunity from "core/components/CDropdownCommunity";
import InfoPersonal from "../components/InfoPersonal";
import CPostItem from "core/components/CPostItem/CPostItem";
import CUser from "core/components/CUser/CUser";
import { useUser } from "modules/Auth/hooks";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import SkeletonListCommunity from "../components/SkeletonListCommunity";
import { useChannel, useUpdateListPost } from "../hooks";
import { useParams } from "react-router-dom";

export const handleMapImagePost = (item?:any) => {
  let image = ''
  if(item?.files?.length > 0){
    image = item?.files[0]?.url?.thumbnail
  }
  return image
}

const PersonalChannelPage = () => {
  useScrollToTop();
  const { userInfo } = useUser();
  const navigate = useCustomNavigate();

  const [idUser, setIdUser] = useState<any>('')
  const { id } = useParams();
  const { 
    loading,
    dataList, 
    loadMore, 
    lastPage, 
    params, 
    statistics, 
    updateStatusFollow, 
    state_follow,
    loadingStatisticFollow, 
  } = useChannel(idUser)
  const [stateFollow, setStateFollow] = useState(state_follow)

  const { updateList } = useUpdateListPost()

  const [emptyData, setEmptyData] = useState(false)
  const [statisticsData, setStatisticsData] = useState(statistics)
  useEffect(() => {
    if (!dataList.length && !loading && params?.page === 1) {
      setEmptyData(true)
    } else {
      setEmptyData(false)
    }
  }, [dataList])

  useEffect(() => {
    setIdUser(id)
  }, [id])

  useEffect(() => {
    setStateFollow(state_follow)
  }, [state_follow])

  useEffect(() => {
    setStatisticsData(statistics)
  }, [statistics])

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if(!isFixed){
        setIsFixed(window.scrollY > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleFetchMore = () => {
    if (loading) {
      return
    }
    if (lastPage > params?.page && !loading) {
      loadMore()
    }
  }

  const handleFollow = () => {
    const stateFollowActive = !stateFollow;
    if(stateFollowActive) {
      statisticsData.total_follows = statisticsData.total_follows + 1
    }else {
      statisticsData.total_follows = statisticsData.total_follows - 1
    }
    setStateFollow(stateFollowActive)
    updateStatusFollow()
  }

  const handleToDetailPost = (id:number) => {
    console.log('id', id)
    navigate(route(RouterName.POST_DETAIL, id))
  }

  
  const handlDropdown = (data?:any) => {
    console.log('handlDropdown', data)
    updateList(data?.id)
  }
  

  const customStyleListPost = `${isFixed ? ' bg-gray-100 !pt-[0px]' : (userInfo?.id == idUser ? ' !pt-[135px]' : (!userInfo?.id ? ' !pt-[135px]' : ' !pt-[211px]'))}`
  return (
    <AppLayout className={` relative no-scrollbar  pb-[70px] ${isFixed ? ' bg-[#ffffff]' : ' bg-gray-100'}`}>
      <PageHeader
        className="fixed w-full z-[200] bg-white"
        title={_t("main.community.title")}
      />
      <div className="px-4 pt-[43px]" />
      <div className="no-scrollbar ">
        <InfoPersonal
          stateFollow={stateFollow} 
          handleFollow={handleFollow} 
          isFixed={isFixed}
          countFollower={statisticsData?.total_follows}
          countShare={statisticsData?.total_posts}
          countLike={statisticsData?.total_reactions}
          name={statisticsData?.name || (statisticsData?.username != undefined ? `@${statisticsData?.username}` : '')}
          image={statisticsData?.avatar?.url?.thumbnail}
          isCurrentUser={userInfo?.id == idUser}
          userInfo={userInfo}
          loading={loadingStatisticFollow}
        />
        <div className={`rounded-lg no-scrollbar ${customStyleListPost}`}>
          <div className={`no-scrollbar ${!dataList.length && loading && params?.page === 1 ? '' : ' min-h-[600px]'}`} id="main-list">
            <div className={`mt-2 ${isFixed ? ' !mt-0 !pt-0' : ''}`}>
              <InfiniteScroll
                dataLength={dataList.length}
                next={handleFetchMore}
                hasMore={!!dataList.length}
                loader={null}
                className=" "
              >
                {dataList.map((item: any, key: number) => (<div key={key} className={`px-4 py-4 mb-2 bg-white post-${item?.id}`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <CUser
                        avatar={item?.user?.avatar?.url?.thumbnail}
                        name={item?.user?.name || '@'+item?.user?.username}
                        id={item?.user_id}
                        date={item?.created_at}
                      />
                    </div>
                    <CDropdownCommunity handleClick={handlDropdown} type="post" id={item?.id} creatorId={item?.user_id} />
                  </div>
                  <CPostItem
                    key={key}
                    className="w-[140px] h-[140px] mb-0"
                    name={""}
                    {...item}
                    item={item}
                    handleClick={()=> handleToDetailPost(item?.id)}
                    title={item?.content}
                    thumbnail={handleMapImagePost(item)}
                    likeCount={item?.total_likes}
                    type="original"
                    commentCount={item?.total_comments}
                    shareCount={item?.total_shares}
                  />
                </div>))}
              </InfiniteScroll>

            </div>
          </div>
        </div>
        {loading ? (
          <div className="grid mt-[-10px]">
            {Array.from(Array(params?.page === 1 ? 10 : 4).keys()).map(
              (e: number) => <SkeletonListCommunity key={e} />
            )}
          </div>
        ) :
          (!dataList.length && !loading && emptyData ? <EmptyData message={_t('main.community.no_data')} /> : null)
        }
      </div>
      <BottomNavigation activeIndex={4} />
    </AppLayout>
  );
};

export default PersonalChannelPage;
